import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../../context/context";
import moment from "moment";
import DateRangePicker from "@wojtekmaj/react-daterange-picker/dist/DateRangePicker";

import "./VolumeCidade.scss";

import {
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";

import LineChart from "../../../components/LineChart/LineChart";
import { getVolumeByCity } from "../../../services/graphics-service";
import { formatGraphicVolumePerCities } from "../../../utils/formatted-graphic-values";
import { getCities } from "../../../services/city-service";
import SelectInput from "../../../components/Select/SelectInput";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
};

const selectValues = [
  { id: 9, name: "Goiás", uf: "GO" },
  { id: 11, name: "Minas Gerais", uf: "MG" },
  { id: 26, name: "São Paulo", uf: "SP" },
];

const VolumeCidade = () => {
  const { sidebar } = useContext(Context);
  const token = localStorage.getItem("token");
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState("");
  const [selectedCities, setSelectedCities] = useState([]);
  const [graphicValues, setGraphicValues] = useState({});
  const [showGraphic, setShowGraphic] = useState(false);
  const [dateValue, setDateValue] = useState([
    moment(new Date()).subtract(30, "day").toDate(),
    new Date(),
  ]);

  const getCitiesList = async () => {
    const city = await getCities(token, states);
    setCities(city);
  };

  useEffect(() => {
    getCitiesList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [states]);

  const getGraphicData = async () => {
    const result = await getVolumeByCity(
      token,
      selectedCities,
      dateValue[0],
      dateValue[1]
    );
    console.log(result);
    setGraphicValues(formatGraphicVolumePerCities(result.data.citiesVolume));

    setShowGraphic(true);
  };

  return (
    <main className={sidebar ? "container" : "container-full"}>
      <h1>Volume perdido por cidade</h1>

      <div className="graphic-csv-container">
        <p>Favor escolher as zonas para gerar o gráfico</p>

        <DateRangePicker onChange={(e) => setDateValue(e)} value={dateValue} />

        <div>
          <SelectInput
            style={{ width: "272px", marginBottom: "10px" }}
            value={states}
            name="Selecione o estado"
            setValue={setStates}
            selectValues={selectValues}
          />
        </div>

        {states && (
          <div>
            <FormControl style={{ width: "272px" }}>
              <InputLabel id="demo-multiple-checkboxx-label">
                Selecione as cidades
              </InputLabel>
              <Select
                labelId="demo-multiple-checkboxx-label"
                id="demo-multiple-checkbox"
                multiple
                value={selectedCities}
                onChange={(e) => setSelectedCities(e.target.value)}
                input={<OutlinedInput label="Selecione as cidades" />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
              >
                {cities.map((item) => (
                  <MenuItem key={item.name} value={item.id}>
                    <Checkbox checked={selectedCities.indexOf(item.id) > -1} />
                    <ListItemText primary={item.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        )}

        <Button
          className="generate-btn"
          variant="contained"
          onClick={getGraphicData}
        >
          Gerar gráfico
        </Button>
      </div>

      {showGraphic && (
        <div className="graphic-container">
          <LineChart values={graphicValues} />
        </div>
      )}
    </main>
  );
};

export default VolumeCidade;
